var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-items-edit',{attrs:{"game-item-variant":"skins"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('skins.edit')))]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }